import { 
    REFERRAL_FAIL, REFERRAL_REQUEST, REFERRAL_SUCCESS, REFERRAL_EDIT_FAIL, REFERRAL_EDIT_REQUEST, REFERRAL_EDIT_SUCCESS
  } from '../constants/referralConstants'
import axios from 'axios'
import { message } from 'antd'

export const referralList = (page, search, source, status, startDate, endDate) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_REQUEST
        })

        if(status) status = status == "active" ? "1" : "0"

        const { data } = await axios.get('referral', {
            params: {
                page,
                search,
                source, status, startDate, endDate
            }
        })

        dispatch({
            type: REFERRAL_SUCCESS,
            payload: data.data
        })
    } catch (e) {
        dispatch({
            type: REFERRAL_FAIL,
            payload: e
        })
    }
}

export const referredList = (id, page, search, update, date, status) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_REQUEST
        })

        const { data } = await axios.get(`referral/list-referred/${id}`, {
            params: {
                page,
                search,
                update, date, status
            }
        })

        dispatch({
            type: REFERRAL_SUCCESS,
            payload: data.data
        })
    } catch (e) {
        dispatch({
            type: REFERRAL_FAIL,
            payload: e
        })
    }
}

export const referralChangeStatus = async (id, status) => {
    try{
        message.loading('Loading...', "updatable")
        const {data} = await axios.post(`referral/update-verified/${id}`, {
            status
        })
        message.success(data?.message, 5)
    }catch{
        message.error("Failed to change status", 5)
    }
}

export const referralEdit = (id) => async (dispatch) => {
  try {
    dispatch({
      type: REFERRAL_EDIT_REQUEST,
    })

    const { data } = await axios.get(`referral/${id}/edit`)

    dispatch({
      type: REFERRAL_EDIT_SUCCESS,
      payload: data
    })
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    dispatch({
      type: REFERRAL_EDIT_FAIL,
      payload: err          
    })
  }
}

export const referralUpdate = async (id, form, history) => {
    try{
        const { data } = await axios.put(`referral/${id}/update`, form)
        message.success(data?.message, 5)
        history.push("/referrals-index")
    }catch (e){
        let errorMsg = e.message; // Fallback
        if (e.response && e.response.data) {
            const data = e.response.data;
            if (data.errors) {
                const firstErrorField = Object.keys(data.errors)[0];
                errorMsg = data.errors[firstErrorField][0];
            } 
            else if (data.message) {
                errorMsg = data.message;
            }
        }

        message.error(errorMsg, 5);
    }
}